<template>
  <b-modal
    id="modal-newClient"
    title="Add new client"
    size="lg"
    body-bg-variant="light"
    header-bg-variant="secondary"
    header-text-variant="white"
    ok-disabled
    centered
  >
    <b-row class="mt-5 justify-content-center">
      <b-col md="5">
        <b-form class="login">
          <b-form-row>
            <b-col cols="12">
              <b-form-group description="Enter company">
                <b-input
                  size="md"
                  required
                  v-model="form.company"
                  type="text"
                  placeholder="Company"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-form>
      </b-col>
    </b-row>
    <template v-slot:modal-footer>
      <b-button
        @click="$bvModal.hide('modal-newClient')"
        class="btn btn-muted btn-md"
      >
        Cancel
      </b-button>
      <b-button
        type="submit"
        @click="onSubmit"
        class="btn btn-dark btn-md"
        :disabled="isSending"
      >
        Create new client
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import axios from "axios";

export default {
  components: {},
  data() {
    return {
      isSending: false,
      form: {
        company: null,
      },
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.isSending = true;
      return new Promise((resolve, reject) => {
        axios({
          url: this.$store.state.login.url + "/api/dashboard/clients/new",
          headers: {
            Authorization: `Bearer ${this.$store.state.login.token}`,
            "Content-Type": "application/json",
          },
          data: JSON.stringify(this.form),
          method: "POST",
        })
          .then((response) => {
            // cleanup form
            this.isSending = false;
            this.$bvModal.hide("modal-newClient");
            this.$router.go();
            this.$bvToast.toast(response.data.message, {
              title: "Success",
              autoHideDelay: 5000,
            });
            resolve(response);
          })
          .catch((err) => {
            this.isSending = false;
            this.$bvToast.toast(err.message, {
              title: "Something went wrong ... ",
              autoHideDelay: 5000,
            });
            reject(err);
          });
      });
    },
  },
};
</script>
